import { REDUCER_NAME } from "./consts";
import { reducer } from "./reducer";
import { selectors } from "./selectors";
import { actions } from "./actions";

export const event = {
  reducerName: REDUCER_NAME,
  selectors,
  actions,
  reducer,
};
